var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',_vm._g(_vm._b({attrs:{"value":_vm.value,"outlined":_vm.outlined,"dense":_vm.dense,"readonly":_vm.readonly,"persistent-placeholder":_vm.persistentPlaceholder,"rules":_vm.rules,"required":_vm.required,"chips":"","multiple":"","append-icon":null},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var attrs = ref.attrs;
var item = ref.item;
var select = ref.select;
var selected = ref.selected;
var index = ref.index;
return [_c('v-chip',_vm._b({attrs:{"input-value":selected,"close":""},on:{"click":select,"click:close":function($event){return _vm.remove(index)}}},'v-chip',attrs,false),[_vm._v(" "+_vm._s(item)+" ")])]}}])},'v-combobox',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }